module.exports = __webpack_public_path__ + "static/banner_cpa_2026-67207fa982b7827402f1b229675ed871.jpeg";